var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('div',{staticStyle:{"display":"none","background-color":"canvas","color-scheme":"light"},attrs:{"id":"detection-theme"}}),_c('router-view'),_c('MainErrors'),_c('modal-portals')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }